// const IMAGE_URL = "http://localhost:5001";
const IMAGE_URL = "https://api.yalladad.com";

export default IMAGE_URL;
